import React from 'react';
import { useSpring } from 'react-spring';
import './BurgerMenu.scss';

const CollapseMenu = props => {
  const { open } = useSpring({ open: props.navbarState ? 0 : 1 });

  if (props.navbarState === true) {
    return (
      <div
        className='collapsed navbar2'
        style={{
          transform: open
            .interpolate({
              range: [0, 0.2, 0.3, 1],
              output: [0, -20, 0, -200]
            })
            .interpolate(openValue => `translate3d(0, ${openValue}px 0)`)
        }}
      >
        <div className='navlinks'>
          <li>
            <a href='/' onClick={props.handleNavbar}>
              Login
            </a>
          </li>
          <li>
            <a href='/' onClick={props.handleNavbar}>
              Register
            </a>
          </li>
        </div>
      </div>
    );
  }
  return null;
};

export default CollapseMenu;
